import * as React from 'react';
type Props = {
  className?: string;
};
export function HrHeart({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-hr-heart"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23649 22.2439C2.80659 18.8587 2.80659 13.3227 6.23649 9.93751C9.51427 6.70246 14.7526 6.60477 18.1488 9.71536L20.002 11.4128L21.8552 9.71536C25.2513 6.60477 30.4897 6.70246 33.7675 9.93751C37.1974 13.3227 37.1974 18.8587 33.7675 22.2439L20.5874 35.2522C20.2628 35.5725 19.7412 35.5725 19.4166 35.2522L6.23649 22.2439Z"
        stroke="currentColor"
        strokeWidth={1.66667}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5191 10.9551L25.7334 13.1693C27.0429 12.1835 28.9579 12.3286 30.2047 13.5754C31.4515 14.8221 31.5966 16.7372 30.6107 18.0467L32.825 20.2609C34.9663 17.7797 34.7728 13.9368 32.308 11.4721C29.8432 9.00728 26.0004 8.81375 23.5191 10.9551Z"
        fill="currentColor"
      />
    </svg>
  );
}
